"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminStudentsTab = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const SortableTable_1 = require("../util/SortableTable");
const UI_1 = require("../util/UI");
const ViewAs_1 = require("../util/ViewAs");
const AdminView_1 = require("./AdminView");
class AdminStudentsTab {
    constructor(remote) {
        this.remote = remote;
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminStudentsTab::init(..) - start");
            document.getElementById("studentListTable").innerHTML = "";
            if (typeof opts.labSection === "undefined") {
                opts.labSection = "-All-";
            }
            UI_1.UI.showModal("Retrieving students.");
            const students = yield AdminStudentsTab.getPeopleForView(this.remote);
            UI_1.UI.hideModal();
            this.render(students, opts.labSection);
        });
    }
    render(students, labSection) {
        Log_1.default.trace("AdminStudentsTab::render(..) - start");
        const headers = [
            {
                id: "num",
                text: "#",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "githubId",
                text: "GitHub Id",
                sortable: true,
                defaultSort: true,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "snum",
                text: "SNUM",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "id",
                text: "CSID",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "fName",
                text: "First Name",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "lName",
                text: "Last Name",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "labId",
                text: "Lab",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "viewAs",
                text: "View As",
                sortable: false,
                defaultSort: false,
                sortDown: true,
                downloadable: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
        ];
        let labSectionsOptions = ["-All-", "-Unspecified-"];
        const st = new SortableTable_1.SortableTable(headers, "#studentListTable");
        let count = 1;
        for (const student of students) {
            let labId = "";
            if (student.labId !== null && student.labId.length > 0) {
                labId = student.labId;
            }
            const snum = AdminStudentsTab.snumLabel(student);
            const row = [
                { value: count, html: count++ + "" },
                {
                    value: student.githubId,
                    html: "<a class='selectable' href='" + student.userUrl + "'>" + student.githubId + "</a>",
                },
                { value: snum, html: snum },
                { value: student.id, html: student.id },
                { value: student.firstName, html: student.firstName },
                { value: student.lastName, html: student.lastName },
                { value: labId, html: labId },
                {
                    value: student.id,
                    html: "<button class='viewAsButton' data-id='" +
                        student.id +
                        "' data-name='" +
                        student.firstName +
                        " " +
                        student.lastName +
                        "'>View As</button>",
                },
            ];
            if (labSectionsOptions.indexOf(student.labId) < 0 && student.labId !== "" && student.labId !== null) {
                labSectionsOptions.push(student.labId);
            }
            if (labSection === student.labId ||
                labSection === "-All-" ||
                (labSection === "-Unspecified-" && (student.labId === "" || student.labId === null))) {
                st.addRow(row);
            }
        }
        st.generate();
        this.wireViewAsButtons();
        labSectionsOptions = labSectionsOptions.sort();
        UI_1.UI.setDropdownOptions("studentsListSelect", labSectionsOptions, labSection);
        const labSelector = document.querySelector("#studentsListSelect");
        const that = this;
        labSelector.onchange = function (evt) {
            Log_1.default.info("AdminStudentsTab::render(..) - lab changed");
            evt.stopPropagation();
            const val = labSelector.value.valueOf();
            that.render(students, val);
        };
        if (st.numRows() > 0) {
            UI_1.UI.showSection("studentListTable");
            UI_1.UI.hideSection("studentListTableNone");
        }
        else {
            UI_1.UI.showSection("studentListTable");
            UI_1.UI.hideSection("studentListTableNone");
        }
    }
    static snumLabel(student) {
        if (student.studentNum === null || typeof student.studentNum === "undefined") {
            return null;
        }
        const snum = String(student.studentNum);
        return snum.length > 0 ? snum : null;
    }
    wireViewAsButtons() {
        const buttons = document.querySelectorAll(".viewAsButton");
        for (const element of Array.from(buttons)) {
            const button = element;
            button.onclick = () => __awaiter(this, void 0, void 0, function* () {
                const personId = button.getAttribute("data-id");
                const name = button.getAttribute("data-name");
                Log_1.default.info("AdminStudentsTab::viewAs( " + personId + " ) - start");
                try {
                    const options = AdminView_1.AdminView.getOptions();
                    options.method = "post";
                    const response = yield fetch(this.remote + "/portal/admin/viewAs/" + personId, options);
                    const json = yield response.json();
                    if (typeof json.success === "undefined") {
                        UI_1.UI.showError(json);
                        return;
                    }
                    ViewAs_1.ViewAs.start(personId, name + " (" + personId + ")");
                    window.location.reload();
                }
                catch (err) {
                    Log_1.default.error("AdminStudentsTab::viewAs( " + personId + " ) - ERROR: " + err.message);
                    UI_1.UI.showError(err.message);
                }
            });
        }
    }
    static getStaff(remote) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminStudentsTab::getStaff( .. ) - start");
            try {
                return yield AdminStudentsTab.getPeople(remote + "/portal/admin/staff");
            }
            catch (err) {
                Log_1.default.error("AdminStudentsTab::getStaff( .. ) - ERROR: " + err.message);
            }
        });
    }
    static getPeopleForView(remote_1) {
        return __awaiter(this, arguments, void 0, function* (remote, view = "students") {
            Log_1.default.info("AdminStudentsTab::getPeopleForView( " + view + " ) - start");
            try {
                return yield AdminStudentsTab.getPeople(remote + "/portal/admin/people/" + view);
            }
            catch (err) {
                Log_1.default.error("AdminStudentsTab::getPeopleForView( .. ) - ERROR: " + err.message);
            }
        });
    }
    static getPeople(url) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminStudentsTab::getPeople( .. ) - start; url: " + url);
            try {
                const start = Date.now();
                const options = AdminView_1.AdminView.getOptions();
                const response = yield fetch(url, options);
                if (response.status === 200) {
                    Log_1.default.trace("AdminStudentsTab::getPeople(..) - 200 received");
                    const json = yield response.json();
                    if (typeof json.success !== "undefined" && Array.isArray(json.success)) {
                        Log_1.default.trace("AdminStudentsTab::getPeople(..)  - worked; # students: " + json.success.length + "; took: " + UI_1.UI.took(start));
                        return json.success;
                    }
                    else {
                        Log_1.default.trace("AdminStudentsTab::getPeople(..)  - ERROR: " + json.failure.message);
                        AdminView_1.AdminView.showError(json.failure);
                    }
                }
                else {
                    Log_1.default.trace("AdminView::getPeople(..)  - !200 received: " + response.status);
                    const text = yield response.text();
                    AdminView_1.AdminView.showError(text);
                }
            }
            catch (err) {
                AdminView_1.AdminView.showError("Getting people failed: " + err.message);
            }
            return [];
        });
    }
}
exports.AdminStudentsTab = AdminStudentsTab;
